<template>
  <pt-manual-reward class="pt-manual-reward__withData" @rewardAudit="rewardAudit" @batchReview="batchReview" :isReview="isReview"
  :statisticsData="statisticsData" @closeDialog='closeDialog' ref="table" @exportManualReward="exportManualReward" :exportLoading="exportLoading"></pt-manual-reward>
</template>

<script>
import PtManualReward from './index'
export default {
  name: 'pt-manual-reward__withData',
  components: {
    'pt-manual-reward': PtManualReward
  },
  data () {
    return {
      isReview: false,
      statisticsData: {},
      loading: false,
      exportLoading: false
    }
  },
  methods: {
    exportManualReward (data) {
      this.exportLoading = true
      this.$store.dispatch('manulRewardExport', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出提现记录失败')
      })
    },
    rewardAudit (ids) {
      this.isReview = true
    },
    batchReview (ids, auditStatus) {
      if (auditStatus === 'SALES_COMPLETED') {
        this.rewardStatistics(ids)
      } else {
        this.batchrewardStatisticsSaler(ids)
      }
    },
    rewardStatistics (ids) {
      this.loading = true
      this.$store.dispatch('batchrewardStatistics', ids).then(res => {
        this.loading = false
        this.statisticsData = res
        if (!res.popupMessage) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条奖励记录中，有' + res.approvedTotal + '条已做过财务审核处理（已完成/已驳回），将对待审核状态的' +
           res.canApprovalTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    },
    batchrewardStatisticsSaler (ids) {
      this.loading = true
      this.$store.dispatch('batchrewardStatisticsSaler', ids).then(res => {
        this.loading = false
        this.statisticsData = res
        if (!res.popupMessage) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条奖励记录中，有' + res.approvedTotal + '条已做过客服审核处理（已完成/已驳回），将对待审核状态的' +
           res.canApprovalTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    },
    closeDialog () {
      this.isReview = false
    }
  }
}
</script>
